/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BookSetting } from '../../models/book-setting';

export interface GetBookSettings$Params {
}

export function getBookSettings(http: HttpClient, rootUrl: string, params?: GetBookSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BookSetting>>> {
  const rb = new RequestBuilder(rootUrl, getBookSettings.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BookSetting>>;
    })
  );
}

getBookSettings.PATH = '/api/books/settings';
